import React from "react"
import { Navigate, useLocation } from "react-router-dom"
import { useAuth } from "../../context/auth-context"
import Login from "../../pages/authentication/login"

const AuthGuard = ({ requireAuth, children }) => {
  const { isAuthenticated, isLoginModalOpen, setIsLoginModalOpen } = useAuth()
  const location = useLocation()

  if (requireAuth && !isAuthenticated) {
    // If not authenticated and login modal is active, show modal
    if (isLoginModalOpen) {
      return <Login onClose={() => setIsLoginModalOpen(false)} />
    }
    // Otherwise redirect to login
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return children
}

export default AuthGuard
